module.exports = __webpack_public_path__ + "static/media/liberty-blue.09d4224d.png";